var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9629 43.5152C40.0265 43.5152 47.374 36.1677 47.374 27.1041C47.374 18.0404 40.0265 10.6929 30.9629 10.6929C21.8993 10.6929 14.5518 18.0404 14.5518 27.1041C14.5518 36.1677 21.8993 43.5152 30.9629 43.5152Z",
    fill: "#179D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6681 36.7049L12.0215 46.493L18.612 46.1431L21.6062 52.0257L26.8297 42.9699C23.087 42.0017 19.8731 39.7479 17.6681 36.7049Z",
    fill: "#083E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2905 36.6561C42.1018 39.7073 38.8879 41.9692 35.1533 42.9537L40.3932 52.0258L43.3874 46.1432L49.9779 46.493L44.2905 36.6561Z",
    fill: "#083E3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9628 38.9995C37.5325 38.9995 42.8582 33.6738 42.8582 27.1041C42.8582 20.5344 37.5325 15.2087 30.9628 15.2087C24.3931 15.2087 19.0674 20.5344 19.0674 27.1041C19.0674 33.6738 24.3931 38.9995 30.9628 38.9995Z",
    fill: "#179D82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.116 25.8185C39.4822 25.4605 39.2788 24.834 38.7743 24.7607L34.0796 24.0773C33.8762 24.0447 33.7053 23.9227 33.6158 23.7356L31.5166 19.4802C31.2888 19.0164 30.6298 19.0164 30.4019 19.4802L28.3109 23.7356C28.2214 23.9146 28.0424 24.0447 27.8471 24.0773L23.1524 24.7607C22.6479 24.834 22.4445 25.4605 22.8107 25.8185L26.2036 29.13C26.35 29.2765 26.4151 29.4799 26.3826 29.6751L25.5852 34.3454C25.4957 34.8499 26.0327 35.2404 26.4883 34.9963L30.6867 32.7914C30.8657 32.6937 31.0854 32.6937 31.2644 32.7914L35.4628 34.9963C35.9184 35.2323 36.4473 34.8499 36.3659 34.3454L35.5604 29.6751C35.5279 29.4717 35.593 29.2683 35.7394 29.13L39.116 25.8185Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.7cce93e1269020c1f33647e18b039222.svg";
export { ForwardRef as ReactComponent };